import { createClient } from '@sanity/client';

export const client = createClient({
    projectId: "u1powisf",
    dataset: "production",
    apiVersion: "2023-07-19",
    useCdn: false
});